import { Injectable } from '@angular/core';
import { Reminder } from 'src/app/model/reminder';
import { Router } from '@angular/router';
import { ReservationService } from '../../reservation.service';
import { Reservation } from '../../../model/reservation';
import { ReportViewer } from '../../../model/report-viewer';
import { EnvironmentPresetService } from '../../environment-preset/environment-preset.service';

@Injectable()
export class ReservationRescheduleWizardService {

  private reminders: Reminder[];
  returnUrl: string;
  private reservation: Reservation;

  constructor(
    private router: Router
    , private environmentPresetService: EnvironmentPresetService
    , private reservationService: ReservationService) {
  }

  clear(): void {
    this.reminders = [];
    this.reservation = null;
    this.returnUrl = '';
  }

  goReminder(reminders: Reminder[], reservation: Reservation, returnUrl: string): void {
    this.reminders = reminders;
    this.reservation = reservation;
    this.returnUrl = returnUrl;
    this.router.navigate(['reservation-reminder']);
  }

  getReminders(): Reminder[] {
    return this.reminders;
  }

  setReservationAndStartWizard(reservation: Reservation, returnUrl: string): void {
    this.reservation = reservation;
    this.returnUrl = returnUrl;
    this.navigateToReservationWizard();
  }

  getReservation(): Reservation {
    return this.reservation;
  }

  async getReminderReport(   ): Promise<ReportViewer> {
    const medicalAppointmentIds: number[] = [];
    this.reminders.forEach((reminder) => medicalAppointmentIds
      .push(reminder.MedicalAppointmentId));
    return await  this.reservationService.getReminderReport( medicalAppointmentIds );
  }

  async getReminderHtml( ): Promise<string> {
    const medicalAppointmentIds: number[] = [];
    this.reminders.forEach((reminder) => medicalAppointmentIds
      .push(reminder.MedicalAppointmentId));
    return await  this.reservationService.getReminderHtml( medicalAppointmentIds );
}

  async sendResevationMail(): Promise<void> {
    const medicalAppointmentIds: number[] = [];
    this.reminders.forEach((reminder) => medicalAppointmentIds
      .push(reminder.MedicalAppointmentId));
    return await this.reservationService.sendResevationMail(medicalAppointmentIds);
  }

  async reschedule() {
    const medicalAppointmentIds: number[] = [];
    this.reminders.forEach((r) => medicalAppointmentIds.push(r.MedicalAppointmentId));
    this.reservation = new Reservation(this.reservation);
    this.reservation.MedicalAppointmentIdsToCancel = medicalAppointmentIds;
    this.navigateToReservationWizard();
  }

  finalize(): void {
   const url = this.returnUrl;
   this.clear();
    if (url !== '') {
      this.router.navigate([url]);
    } else {
      this.navigateToReservationWizard();
    }
  }

  public navigateToReservationWizard(): void {
      this.router.navigate(['reservation-wizard']);
  }
}
